/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLineDotted = createReactComponent("outline", "line-dotted", "IconLineDotted", [["path", { "d": "M4 12v.01", "key": "svg-0" }], ["path", { "d": "M8 12v.01", "key": "svg-1" }], ["path", { "d": "M12 12v.01", "key": "svg-2" }], ["path", { "d": "M16 12v.01", "key": "svg-3" }], ["path", { "d": "M20 12v.01", "key": "svg-4" }]]);

export { IconLineDotted as default };
//# sourceMappingURL=IconLineDotted.mjs.map
